import { Grid, Button, Heading } from '@enterprise-ui/canvas-ui-react';
import EnterpriseIcon, { ChevronLeftIcon, ChevronRightIcon } from '@enterprise-ui/icons';
import React from 'react';
import { headerFormat } from '../utils/utility.js';

function RawNavHeader(_ref) {
  var activeMonth = _ref.activeMonth,
    selectMonth = _ref.selectMonth;
  return /*#__PURE__*/React.createElement(Grid.Container, {
    className: "hc-pr-normal hc-pt-normal hc-pl-normal",
    align: "center",
    spacing: "none"
  }, /*#__PURE__*/React.createElement(Grid.Item, null, /*#__PURE__*/React.createElement(Button, {
    "data-test": "popUpPrev",
    iconOnly: true,
    size: "dense",
    "aria-label": "previous month",
    className: "C-DatePicker__NavButton",
    onClick: function onClick() {
      return selectMonth('prev');
    }
  }, /*#__PURE__*/React.createElement(EnterpriseIcon, {
    icon: ChevronLeftIcon
  }))), /*#__PURE__*/React.createElement(Grid.Item, {
    xs: true,
    className: "hc-ta-center",
    "aria-live": "polite"
  }, /*#__PURE__*/React.createElement(Heading, {
    size: 6
  }, headerFormat(activeMonth))), /*#__PURE__*/React.createElement(Grid.Item, null, /*#__PURE__*/React.createElement(Button, {
    "data-test": "popUpNext",
    iconOnly: true,
    size: "dense",
    className: "C-DatePicker__NavButton",
    "aria-label": "next month",
    onClick: function onClick() {
      return selectMonth('next');
    }
  }, /*#__PURE__*/React.createElement(EnterpriseIcon, {
    icon: ChevronRightIcon
  }))));
}
RawNavHeader.displayName = 'NavHeader';
var NavHeader = /*#__PURE__*/React.memo(RawNavHeader);

export { NavHeader as default };
